import { render, staticRenderFns } from "./DateEdit.vue?vue&type=template&id=0671197f&scoped=true"
import script from "./DateEdit.vue?vue&type=script&lang=js"
export * from "./DateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671197f",
  null
  
)

export default component.exports